import { render, staticRenderFns } from "./AddNewCompanyHolidayPopUp.vue?vue&type=template&id=4648a600&scoped=true&"
import script from "./AddNewCompanyHolidayPopUp.vue?vue&type=script&lang=js&"
export * from "./AddNewCompanyHolidayPopUp.vue?vue&type=script&lang=js&"
import style0 from "./AddNewCompanyHolidayPopUp.vue?vue&type=style&index=0&id=4648a600&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4648a600",
  null
  
)

export default component.exports